import * as React from 'react';

// Context lets us pass a value deep into the component tree
// without explicitly threading it through every component.
export const CampaignContext = React.createContext({});
// export const OrganizationContext = React.createContext({});